import { etiquetaOrigen, origenesActivos, type OrigenConfig } from '@barbones/shared';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/cliente';

/** Opciones de «Cómo nos encontró» configuradas (incluidas las que ya no se ofrecen, para sus etiquetas). */
export function useOrigenes() {
  const consulta = useQuery({ queryKey: ['clientes', 'origenes'], queryFn: () => api<OrigenConfig[]>('/clientes/origenes'), staleTime: 60_000 });
  const lista = consulta.data ?? [];
  return {
    lista,
    activos: origenesActivos(lista),
    etiqueta: (clave: string) => etiquetaOrigen(lista, clave),
    cargando: consulta.isPending,
  };
}
